module.exports = __webpack_public_path__ + "static/media/Broadcast_001.81f974a8.png";